export const BIRTH_POINT = { id: 'birth_point', label: 'Punto nascita pubblico o privato' };
/* export const HOME = { id: 'home', label: 'Abitazione privata (parto domiciliare programmato)' };
export const OTHER_CASE_FACILITY = {
  id: 'other_care_facility',
  label: 'Altra struttura di assistenza (casa di maternità)',
}; */
export const OTHER = {
  id: 'other',
  label: 'Altro luogo non programmato (strada, mezzi di trasporto)',
};
export const STAM = { id: 'stam', label: 'Sistema di Trasporto Materno Assistito (STAM)' };
